module.exports = __webpack_public_path__ + "static/media/image1.0b7c5bd5.png";